import { Component, OnInit } from '@angular/core';
import { environment as configs } from 'src/environments/environment';
import { NzMessageService } from 'ng-zorro-antd';
import { CommonService } from "../common.service";
import { HttpClient, HttpParams, HttpEventType, HttpResponse, HttpRequest, HttpHeaders } from '@angular/common/http';
import { IMyDpOptions, } from 'mydatepicker';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { NzModalService } from 'ng-zorro-antd';
import { ActivatedRoute,Router } from '@angular/router'

@Component({
  selector: 'app-third-party-verify',
  templateUrl: './third-party-verify.component.html',
  styleUrls: ['./third-party-verify.component.css']
})
export class ThirdPartyVerifyComponent implements OnInit {

 	public workerRegNo: any;
	public host = configs['ApiHost'];

	public workerInfo:any;
	public workerFamily:any;
	public workerObjection:any;
	public paydetail:any;
	isFound=false
	constructor(private _message: NzMessageService, private httpClient: HttpClient, private aroute: ActivatedRoute, private rt:Router,private modalService: NzModalService, private CSF: CommonService) { this.CSF.setNavs(false); }
	ngOnInit() {
	}


	searchWorker() {
		// console.log(this.workerRegNo);
		if (this.workerRegNo != "" && this.workerRegNo!=undefined) {
			this.CSF.setBusyStatus(true);
			this.httpClient.post(this.host + '/get/registration/Details/by-wrg', { regno: this.workerRegNo }).subscribe(resp => {
				this.CSF.setBusyStatus(false);
				if(this.workerInfo=resp['data'].length>0){
					this.isFound=true;
					this.workerInfo=resp['data'][0]
					this.workerFamily=resp['data']
					this.paydetail=resp['payment'][0]
				}
				// console.log(this.workerInfo)

			})
		}else{
		}

	}

	substrDate(d){
		let td=d.substr(0,10).split('-');
		return td[2]+'-'+td[1]+'-'+td[0];
	}
}
